import { clsb, clsm } from 'js/utils/classNames.util';

/**
 * @deprecated Use {@link clsb} instead.
 */
export const buildClassName = (classKeys = [], ...args) => cls(args, classKeys);

/**
 * @deprecated Use {@link clsm} instead.
 */
export const mergeClassNames = (classKeys, ...styles) => clsm(styles, classKeys);

/**
 * @deprecated Use {@link clsb} instead.
 */
export const cls = clsb;

/**
 * @deprecated Use {@link clsb} instead.
 */
export default buildClassName;
